import TextWithInlineColor from '../TextWithInlineColor';
import { PhotoAndTextCardFieldsFragment } from '../../../@types/generated';
import { Paragraph, Subheading } from 'components/src/typography';
import ISKFormat from '../common/ISKFormat';
import RichText from '@/components/RichTextSection/RichText';
import * as React from 'react';

type Props = {
  data: PhotoAndTextCardFieldsFragment;
};

const HeadingAndDescriptionSection = ({ data }: Props) => {
  return (
    <>
      {data.subheading && (
        <Subheading small classes="mb-8">
          {data.subheading}
        </Subheading>
      )}
      {data.heading?.text && (
        <div className="mb-16">
          <TextWithInlineColor
            heading={data.heading.text.json}
            color={data.heading.color}
            headingVariant={'xl'}
            textColor="black-50"
          />
        </div>
      )}
      {data.underHeading && (
        <Subheading classes="mb-16" bold>
          {data.underHeading}
        </Subheading>
      )}
      {data.richTextDescription && (
        <div className="whitespace-break-spaces text-black-50">
          {data.richTextDescription?.richText && (
            <div className={`flex flex-col gap-16`}>
              <RichText
                data={data.richTextDescription?.richText}
                textAlignment={data.richTextDescription?.textAlignment}
                isFilloutStandardEmbed={!!data.richTextDescription?.isFilloutStandardEmbed}
                paragraphVariant="medium"
              />
            </div>
          )}
        </div>
      )}
      {data.price && (
        <div className="mt-16 flex items-center gap-x-8">
          <ISKFormat
            value={data.price}
            renderText={(value) => (
              <Paragraph variant="large" classes="!font-bold text-black-50">
                {value}
              </Paragraph>
            )}
          />
          {data.priceSuffix && (
            <Paragraph variant="medium" classes="text-black-50">
              {data.priceSuffix}
            </Paragraph>
          )}
        </div>
      )}
    </>
  );
};
export default HeadingAndDescriptionSection;
